import { useState, useEffect } from 'react'
import api from '../../utils/api'
import AdminLayout from '../../components/admin/AdminLayout'
import './Admin.css'

export default function AdminStatistics() {
  const [stats, setStats] = useState<any>(null)
  const [semesters, setSemesters] = useState<any[]>([])
  const [selectedSemester, setSelectedSemester] = useState<number | null>(null)

  useEffect(() => {
    loadSemesters()
  }, [])

  useEffect(() => {
    loadStatistics()
  }, [selectedSemester])

  const loadSemesters = async () => {
    try {
      const res = await api.get('/semesters')
      setSemesters(res.data)
    } catch (err) {
      console.error(err)
    }
  }

  const loadStatistics = async () => {
    try {
      const url = selectedSemester 
        ? `/admin/statistics?semesterId=${selectedSemester}`
        : '/admin/statistics'
      const res = await api.get(url)
      setStats(res.data)
    } catch (err) {
      console.error(err)
    }
  }

  return (
    <AdminLayout>
      <div className="admin-page">
        <h1>통계</h1>
      <div className="form-row">
        <label>학년도/계절:</label>
        <select value={selectedSemester || ''} onChange={(e) => setSelectedSemester(e.target.value ? parseInt(e.target.value) : null)}>
          <option value="">전체</option>
          {semesters.map(s => (
            <option key={s.id} value={s.id}>{s.year}년 {s.season}</option>
          ))}
        </select>
      </div>
      {stats && (
        <div className="stats-grid">
          <div className="stat-card">
            <h2>전체 수강신청</h2>
            <p className="stat-number">{stats.totalEnrollments}</p>
          </div>
          <div className="stat-card">
            <h2>강의별 통계</h2>
            <table>
              <thead>
                <tr>
                  <th>강좌명</th>
                  <th>정원</th>
                  <th>신청</th>
                </tr>
              </thead>
              <tbody>
                {stats.courseStats?.map((c: any) => (
                  <tr key={c.id}>
                    <td>{c.title}</td>
                    <td>{c.capacity}</td>
                    <td>{c.enrollment_count}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="stat-card">
            <h2>기관별 통계</h2>
            <table>
              <thead>
                <tr>
                  <th>기관명</th>
                  <th>신청수</th>
                </tr>
              </thead>
              <tbody>
                {stats.institutionStats?.map((i: any) => (
                  <tr key={i.id}>
                    <td>{i.name}</td>
                    <td>{i.enrollment_count}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
      </div>
    </AdminLayout>
  )
}

